
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  display:flex;
  width:100%;
}
::slotted([slot='links']){
  display:flex;
  align-items:center;
  gap:0.5rem;
  flex:1;
  justify-content:space-between;
}
.utility-nav-container{
  display:flex;
  flex:1;
}
.utility-nav-links-container{
  display:flex;
  flex:1;
}
@media (min-width: 1024px){
  ::slotted([slot='links']){
    justify-content:flex-start;
  }
  :host{
    width:auto;
  }
}
`;